import { ArrowRight } from '@core/ui';
import type { LinkProps } from '@online-webinar/router';
import { Link } from '@tanstack/react-router';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface LinkCardProps extends Pick<LinkProps, 'to' | 'params' | 'state'> {
    count?: number;
    icon: ReactNode;
    isBeta?: boolean;
    linkText?: string;
    title: string;
}

export const LinkCard = ({ count, icon, isBeta, to, params, state, linkText, title }: LinkCardProps) => {
    const { t } = useTranslation();

    return (
        <li className="group relative bg-primary rounded-lg flex flex-col items-center text-card-color outline outline-primary outline-0 hover:outline-4 focus-within:outline-4 p-4 shadow-lg shadow-primary/0 hover:shadow-primary/40 focus-within:shadow-primary/40 transition-all ease-in-out duration-200 motion-reduce:duration-0">
            {icon}
            <p className="flex-1 flex flex-col font-accent text-2xl text-center mb-4">
                <span className="block flex-1 font-bold text-4xl md:text-5xl mb-1">{count}</span>
                {title}
            </p>
            {isBeta && (
                <div className="absolute -top-3 -right-3 bg-white rounded-md border-2 border-primary text-body font-medium text-base px-2 py-1 uppercase">
                    {t('Beta.Text.Icon')}
                </div>
            )}
            <Link to={to} params={params} state={state} className="block font-medium inline-flex items-center after:absolute after:inset-0">
                {linkText ?? `${t('Manage.Link.ManagePrepend')} ${title.toLocaleLowerCase()}`}
                <ArrowRight classNames="h-auto w-2.5 ml-2 stroke-current fill-transparent group-hover:fill-current transition-color ease-in-out duration-200" />
            </Link>
        </li>
    );
};
